import { createReducer, on } from '@ngrx/store';
import { LoadingInfo } from '@scip/api';
import * as ProductsPageActions from './products-page.actions';

export const configureSortField = (tableState: LoadingInfo): LoadingInfo => {
  // This is needed as there is no property product.name on backend side for dossiers --> product.resource.name
  if (tableState?.sortField === 'product.name') {
    return {
      ...tableState,
      sortField: 'product.resource.name'
    };
  }
  return { ...tableState };
};

export interface State {
  tableState: LoadingInfo;
  userSettings: Record<string, any>;
  error: Error;
}

export const PRODUCTS_PAGE_FEATURE_KEY = 'productsPage';

export const initialState: State = {
  tableState: {
    first: 0,
    rows: 50
  },
  userSettings: null,
  error: null
};

export const productsPageReducer = createReducer(
  initialState,
  on(ProductsPageActions.clear, () => ({
    ...initialState
  })),
  on(ProductsPageActions.setTableState, (state, { tableState }) => ({
    ...state,
    tableState: { ...tableState }
  })),
  on(ProductsPageActions.setLatestSearchId, (state, { searchId }) => ({
    ...state,
    tableState: {
      ...state.tableState,
      searchId
    }
  })),
  on(ProductsPageActions.setUserSettingsSuccess, (state, { settings }) => ({
    ...state,
    tableState: {
      ...state.tableState,
      first: 0,
      rows: settings?.rows ? settings.rows : 50,
      filters: {...settings?.filters},
      searchId: state.tableState?.searchId
    },
    userSettings: {
      ...configureSortField(settings),
      filters: {...settings?.filters}
    }
  })),
  on(ProductsPageActions.setUserSettingsFail, (state, { error }) => ({
    ...state,
    error: error
  })),
  on(ProductsPageActions.getUserSettingsSuccess, (state, { settings }) => ({
    ...state,
    tableState: {
      // ...configureSortField(settings),
      first: 0,
      rows: settings?.rows ? settings.rows : 50,
      filters: {...settings?.filters},
      searchId: state.tableState?.searchId
    },
    userSettings: {
      ...configureSortField(settings),
      filters: {...settings?.filters}
    }
  })),
  on(ProductsPageActions.getUserSettingsFail, (state, { error }) => ({
    ...state,
    error
  })),
  on(ProductsPageActions.resetFilters, (state) => ({
    ...state,
    tableState: {
      ...state.tableState,
      filters: {}
    },
    userSettings: {
      ...state.userSettings,
      filters: {}
    }
  }))
);
